<template>
    <div v-if="show">
        <transition name="fade">
            <div class="modelPhoneBox">
                <div class="modelPhoneBox-mask" @click.stop="close"></div>
                <div class="modelPhoneBox-main">
                    <span class="modelPhoneBox-title">联系酒店</span>
                    <div class="phoneul">
                        <div class="phoneli one-line" 
                            v-for="item in phoneList" 
                            :key="item"
                            @click.stop="phoneCallTask(item)">
                            <span class="phonetext">酒店电话：</span>
                            <span class="phonenum">{{item}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    name: 'phoneList',
    data() {
        return {
            show: true,
            phoneList: []
        }
    },
    methods: {
        close() {
            this.show = false
        },
        phoneCallTask(phone) {
            location.href = `tel:${phone}`
            this.show = false
        }
    }
}
</script>
<style lang="scss">
.modelPhoneBox {
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
}
.modelPhoneBox-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
}
.modelPhoneBox-main {
    background: #fff;
    width: 75%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px 25px;
    box-sizing: border-box;
    border-radius: 4px;
}
.modelPhoneBox-title {
    text-align: center;
    width:100%;
    display:block;
    margin-bottom: 15px;
    font-size: 18px;
    color: #666;
}
.phoneli {
    margin-bottom: 8px;
    line-height: 16px;
}
.phoneli:last-child {
    margin-bottom: 0;
}
.phonetext {
    color: #333;
    font-size: 16px;
}
.phonenum {
    color: #00a0ff;
    font-size: 16px;
}
.btn_son {
	display: -webkit-box;
	width: 100%;
	height: 100%;
	-webkit-box-align: center;
	-webkit-box-pack: center;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/plugins/phone/index.vue